import { type ColorTokens, useTheme } from '@repo/theme';
import type { FormatParams, TLabel } from 'util/stdtypes';

import { BaseTag } from './base-tag';

export type TitleTagType = 'admin' | 'journalist' | 'celebrity' | 'you';

function tagConfig(colors: ColorTokens): Record<TitleTagType, { backgroundColor: string; color: string }> {
    return {
        admin: {
            backgroundColor: colors.colorTagAccentLight,
            color: colors.colorTextOnTagLight,
        },
        journalist: {
            backgroundColor: colors.colorTagHighlight,
            color: colors.colorTextOnTagLight,
        },
        celebrity: {
            backgroundColor: colors.colorTagVerified,
            color: colors.colorTextOnTagLight,
        },
        you: {
            backgroundColor: colors.colorTagAccent,
            color: colors.colorTextOnAccentColorBg,
        },
    };
}

type TitleTagProps = {
    type: TitleTagType;
    title?: string;
    label?: TLabel;
    formatParams?: FormatParams;
};

export function TitleTag({ type, title, label, formatParams }: TitleTagProps) {
    const { colors } = useTheme();
    if (!title && !label) return null;

    const config = tagConfig(colors)[type];

    return (
        <BaseTag
            backgroundColor={config.backgroundColor}
            color={config.color}
            formatParams={formatParams}
            label={label}
            text={title}
            type='small'
        />
    );
}
